import {
  ODataHeader,
  ODataString,
  ODataEnum,
  ODataBoolean,
  ODataDate,
  ODataInteger,
  ODataDecimal,
  HeaderAlignment,
  ODataDateTime
} from "pbas-vue-components";
import {
  translate
} from '../trans'
import store from '@/store'
import { translate2 } from '../trans2'
import { i18n } from '@/plugins/i18n';

const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2
});

export default [
  new ODataHeader({
    title: "Id",
    type: new ODataString("Id"),
    sortable: true,
    visible: false,
    searchable: false,
    isIdentifier: true,
    allowVisibilityChange: false,
    version: 1,
  }),
  new ODataHeader({
    title: "headers.pendinghourstasks.task",
    type: new ODataEnum("Task", {
      getString: (item) => {
        return i18n.t("enums." + item.Task);
      },
      dropdownItems: store.getters['plansMembers/options']?store.getters['plansMembers/options'].Enums.ImportTaskType:[]
    }),
    sortable: true,
    visible: true,
    searchable: true
  }),
  new ODataHeader({
    title: "Task Identifier",
    type: new ODataString("TaskIdentifier"),
    sortable: false,
    visible: false,
    searchable: false
  }),
  new ODataHeader({
    title: "headers.pendinghourstasks.created_by",
    type: new ODataString("CreatedBy"),
    sortable: true,
    visible: true,
    searchable: true,
    allowVisibilityChange: true,
  }),
  new ODataHeader({
    title: "globals.timestamp",
    type: new ODataDateTime("Timestamp"),
    sortable: true,
    visible: true,
    searchable: true,
    allowVisibilityChange: true,
  }),
];
